


























































































import { Component, Vue } from 'vue-property-decorator';
import '../../assets/css/AccountSetup.scss';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { ProfileRequest } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { ObjectFactory } from '../../config/objectFactory';
import { Questionnaire } from '@/types/entity';
// tslint:disable-next-line: no-var-requires
const ProfileFormData = require('../../config/ProfileFormData');
@Component({
    mixins: [validationMixin],
    props: {
        request: Object,
    },
validations: {
        request: {
            questionnaires: {
                required,
                $each: {
                    answer: {
                        required,
                    },
                },
            },
        },
    },
})
export default class TransportationQuestionnaire extends Vue {
    private show = false;
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    public mounted() {
        if (this.$v) {
            this.$v.$touch();
        }
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('homeHealthCare')) {
            const profileRequest = this.getProfileRequest();
            profileRequest.isStepQnValid = false;
            if (!profileRequest.isStepPIValid) {
                this.$router.push({ name: MedTransGoConstants.VIEW_PERSONAL_INFO_NAME });
            }
        } else {
            this.$router.push({ name: MedTransGoConstants.VIEW_PERSONAL_INFO_NAME });
        }
    }

    private getProfileRequest(): ProfileRequest {
        return this.$props.request as ProfileRequest;
    }
    private back() {
        this.$router.push({ name: MedTransGoConstants.VIEW_PERSONAL_INFO_NAME });
    }

    private async completeRegistration() {
        const profileRequest: ProfileRequest = this.$props.request;
        if (this.sessionInfo.scopes.includes('transporter') &&
            profileRequest.updatePartnerProfileRequest.transporterProfile) {
            const transporterQuestionnaires: Questionnaire[] = [];
            profileRequest.questionnaires.forEach((element) => {
                transporterQuestionnaires.push({
                    question: element.question,
                    answer: element.answer.toString(),
                });
            });
            profileRequest.updatePartnerProfileRequest.transporterProfile.questionnaires = transporterQuestionnaires;
        }
        if (this.sessionInfo.scopes.includes('homeHealthCare') &&
            profileRequest.updatePartnerProfileRequest.homeHealthCareProfile) {
            const homeHealthCareQuestionnaires: Questionnaire[] = [];
            profileRequest.questionnaires.forEach((element) => {
                const index = ProfileFormData.homeHealthCareQuestionnaires.findIndex((questionarie: Questionnaire) => {
                    return element.question === questionarie.question;
                });
                if (index >= 0) {
                    homeHealthCareQuestionnaires.push({
                        question: element.question,
                        answer: element.answer.toString(),
                    });
                }
            });
            profileRequest.updatePartnerProfileRequest.homeHealthCareProfile.questionnaires =
                homeHealthCareQuestionnaires;
        }
        if (this.sessionInfo.scopes.includes('transporter')) {
            const updatePartnerProfileResponse = await ObjectFactory.getPartnerService()
                .updatePartnerProfile(profileRequest.updatePartnerProfileRequest, this.$store.state.serverUrl);
            if (updatePartnerProfileResponse.success) {
                this.$router.push({ name: MedTransGoConstants.VIEW_DRIVER_INFO_NAME });
                this.$props.request.isStepQnValid = true;
            }
        } else if (this.sessionInfo.scopes.includes('homeHealthCare')) {
             const updatePartnerProfileResponse = await ObjectFactory.getPartnerService()
                .updatePartnerProfile(profileRequest.updatePartnerProfileRequest, this.$store.state.serverUrl);
             if (updatePartnerProfileResponse.success) {
                this.$router.push({ name: MedTransGoConstants.VIEW_HEALTH_INSURANCE_INFO_NAME });
                this.$props.request.isStepQnValid = true;
            }
         }
    }

    private getQuestionCounter(index: number) {
        const counter = ++index;
        return counter;
    }

    private onSelectSection(index: any) {
        if (this.$v) {
            this.$v.$touch();
        }
        index = parseInt(index, 10);
        const profileRequest: ProfileRequest = this.$props.request;
        const previousAnswer = profileRequest.questionnaires[index].previousAnswer;
        if (previousAnswer) {
            previousAnswer.forEach((existingSection) => {
                let totalLength = 0;
                if (existingSection && ProfileFormData.subQuestions[existingSection]) {
                    const existingQuestions = ProfileFormData.subQuestions[existingSection];
                    totalLength += existingQuestions.length;
                }
                profileRequest.questionnaires.splice(index + 1, totalLength);
            });
        }
        profileRequest.questionnaires[index].answer.forEach((value: string) => {
            if (ProfileFormData.subQuestions[value]) {
                const childQuestions = ProfileFormData.subQuestions[value];
                const newQuestionArray = [];
                for (let i = 0; i <= index; i++) {
                    const element = profileRequest.questionnaires[i];
                    newQuestionArray.push(element);
                }
                childQuestions.forEach((element: any) => {
                    newQuestionArray.push(element);
                });
                for (let i = index + 1; i < profileRequest.questionnaires.length; i++) {
                    const element = profileRequest.questionnaires[i];
                    newQuestionArray.push(element);
                }
                profileRequest.questionnaires = newQuestionArray;
            }
        });
        profileRequest.questionnaires[index].previousAnswer = profileRequest.questionnaires[index].answer;
    }

    private onAnswerChange(index: any) {
        index = parseInt(index, 10);
        const profileRequest: ProfileRequest = this.$props.request;
        const childQuestions = profileRequest.questionnaires[index].childQuestions;
        if (childQuestions) {
            const answer = profileRequest.questionnaires[index].answer;
            if (answer) {
                const newQuestionArray = [];
                for (let i = 0; i <= index; i++) {
                    const element = profileRequest.questionnaires[i];
                    newQuestionArray.push(element);
                }
                childQuestions.forEach((element) => {
                    newQuestionArray.push(element);
                });
                for (let i = index + 1; i < profileRequest.questionnaires.length; i++) {
                    const element = profileRequest.questionnaires[i];
                    newQuestionArray.push(element);
                }
                profileRequest.questionnaires = newQuestionArray;
            } else if (profileRequest.questionnaires.length > profileRequest.totalDocumentCount) {
                profileRequest.questionnaires.splice(index + 1, childQuestions.length);
            }
        }
    }
}
